module.exports = __webpack_public_path__ + "img/car-grey.6dd0b0d7.svg";